module.exports = __webpack_public_path__ + "img/versocommerce.52d26734.png";